import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import ResizeDetector from "react-resize-detector";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import AppHeader from "layout/AppHeader";
import AppSidebar from "layout/AppSidebar";
import AppFooter from "layout/AppFooter";
import BpmnModeler from "components/organism/BpmnModeler/BpmnComponent";

const BpmnModels = (props) => {
  const { t } = useTranslation();
  const {
    colorScheme,
    enableFixedHeader,
    enableFixedSidebar,
    enableFixedFooter,
    enableMobileMenu,
    enablePageTabsAlt,
  } = props;

  return (
    <ResizeDetector
      handleWidth
      render={({ width }) => (
        <Fragment>
          <div
            className={cx(
              "app-container app-theme-" + colorScheme,
              { "fixed-header": enableFixedHeader },
              { "fixed-sidebar": enableFixedSidebar || width < 1250 },
              { "fixed-footer": enableFixedFooter },
              { "closed-sidebar": true },
              {
                "closed-sidebar-mobile": true,
              },
              { "sidebar-mobile-open": enableMobileMenu },
              { "body-tabs-shadow-btn": enablePageTabsAlt }
            )}
          >
            <AppHeader />
            <div className="app-main">
              <AppSidebar />
              <div className="app-main__outer">
                <div className="app-main__inner">
                  <CSSTransitionGroup
                    component="div"
                    transitionName="TabsAnimation"
                    transitionAppear={true}
                    transitionAppearTimeout={0}
                    transitionEnter={false}
                    transitionLeave={false}
                  >
                    <div className="app-page-title">
                      <h5 className="text-primary">{t("createWorflow.titleNav")}</h5>
                    </div>
                  </CSSTransitionGroup>
                </div>
                <BpmnModeler />
                <AppFooter />
              </div>
            </div>
          </div>
        </Fragment>
      )}
    />
  );
};

const mapStateToProp = (state) => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
});

BpmnModels.propTypes = {
  colorScheme: PropTypes.any.isRequired,
  enableFixedHeader: PropTypes.any.isRequired,
  enableFixedSidebar: PropTypes.any.isRequired,
  enableFixedFooter: PropTypes.any.isRequired,
  enableMobileMenu: PropTypes.any,
  enablePageTabsAlt: PropTypes.any.isRequired,
};

export default withRouter(connect(mapStateToProp)(BpmnModels));
